import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        cardContent: {
            height: 1600,
        },
        title: {
            '&&': {
                marginTop: theme.spacing(5),
            },
        },
    }
})

export default useStyles
